import { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Nfc } from "lucide-react";
import { api } from "@/api";

export default function SupportRedirect() {
  const { supportCode } = useParams();
  const [state, setState] = useState({ status: "loading" });

  useEffect(() => {
    let active = true;
    setState({ status: "loading" });
    api
      .get(`/nfc-supports/resolve/${encodeURIComponent(supportCode)}`)
      .then(({ data }) => active && setState(data))
      .catch(() => active && setState({ status: "unavailable" }));
    return () => {
      active = false;
    };
  }, [supportCode]);

  if (state.status === "assigned" && state.restaurant_slug) {
    return <Navigate to={`/review/${state.restaurant_slug}`} replace />;
  }

  const messages = {
    disabled: "Este dispositivo ya no está activo.",
    unavailable: "Este dispositivo todavía no está disponible.",
    available: "Este dispositivo todavía no está disponible.",
  };

  return (
    <div className="relative min-h-screen bg-[#FDFBF7] text-[#1C1917] flex items-center justify-center px-5">
      <div className="ambient-glow" />
      <div className="grain-overlay" />
      <div className="relative z-10 text-center" data-testid="support-page">
        {state.status === "loading" ? (
          <p
            data-testid="support-loading"
            className="font-mono-label text-[10px] uppercase tracking-[0.3em] text-[#A8A29E] animate-pulse"
          >
            Cargando...
          </p>
        ) : (
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            className="flex flex-col items-center gap-4"
            data-testid={
              state.status === "disabled" ? "support-disabled" : "support-unavailable"
            }
          >
            <Nfc className="h-8 w-8 text-[#C25E38]" />
            <h1 className="font-serif-display text-2xl sm:text-3xl font-medium tracking-tight max-w-xs leading-snug">
              {messages[state.status] || messages.unavailable}
            </h1>
            <p className="text-sm text-[#57534E] max-w-xs">
              Si crees que es un error, avisa al personal del restaurante.
            </p>
          </motion.div>
        )}
      </div>
    </div>
  );
}
